var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('dashboard-dropdown-section',{attrs:{"title":"Offers Posted","type":"practice-created-offers","items-shown":5,"items":_vm.offers,"event-name":"load-practice-offers"},on:{"load-practice-offers":_vm.loadMore}})}
var staticRenderFns = []

export { render, staticRenderFns }